module.exports = __webpack_public_path__ + "img/the-professional-footballer.4b23658f.svg";